module.exports = __webpack_public_path__ + "img/logo.7876efd8.png";